import React, {Children, useMemo} from 'react';
import {getValidChildren} from '../../../common/shared/utils/getValidChildren';
import {twMerge} from '../../../common/twMerge';
import {Separator} from '../../atoms/Separator/Separator';
import {WithSeparatorProps} from './WithSeparatorProps.interface';

export function WithSeparator({
  children,
  separatorType,
  useStaticDot,
  separatorStyle,
  separatorClassName,
  disableSeparator,
}: WithSeparatorProps) {
  const validChildren = getValidChildren(children);
  const childrenCount = Children.count(validChildren);

  const separator = useMemo(
    () => (
      <Separator
        type={separatorType}
        useStaticDot={useStaticDot}
        className={twMerge('cursor-default select-none', separatorClassName)}
        style={separatorStyle}
      />
    ),
    [separatorType, useStaticDot, separatorClassName, separatorStyle]
  );

  if (childrenCount === 0) {
    return null;
  }

  return (
    <>
      {Children.map(validChildren, (child, index) => {
        const showSeparator = index !== 0 && !disableSeparator;
        return (
          <React.Fragment key={`with_separator_${index}`}>
            {showSeparator && separator}
            {child}
          </React.Fragment>
        );
      })}
    </>
  );
}
